#import "@/apollo/fragments/MasterTemplate.gql"

mutation ResizeMasterTemplate(
    $masterTemplateId: ID!
    $campaignId: ID
    $width: Float!
    $height: Float!
    $generatedSourceDocument: SCALAR_MIXED
) {
    resizeMasterTemplate(
        masterTemplateId: $masterTemplateId
        campaignId: $campaignId
        width: $width
        height: $height
        generatedSourceDocument: $generatedSourceDocument
    ) {
        ...MasterTemplate
    }
}
